export interface UserInvitation {
    id?: string;
    email: string;
    status: UserInvitationStatus;
    createdAt: Date
    acceptedAt?: Date
    role: UserRole
}

export type UserInvitationStatus = 'new' | 'sent' | 'accepted' | 'paused';

export enum UserRole {
    ADMIN = 'admin',
    MEMBER = 'member',
    WORKER = 'worker',
}
